/* Globals: jQuery */

(function($) {
    $.widget("ca.caCheckboxListSelect", {
        options: {
            multiple: false,
            width : '275px',
            maxHeight: '340px',
            divClass: '',
            displaySelectedText: true,
            $multiselectContainer: '',
            $checkboxItemsContainer: '',
            showTitle: 1,
            multiselectOptions: {
                includeSelectAllOption: true,
                enableFiltering: true,
                enableClickableOptGroups: true,
                enableCollapsibleOptGroups: false,
                enableCaseInsensitiveFiltering: true,
                buttonWidth: 275,
                buttonClass: '',
                enableHTML: true,
                disabledText: '',
                includeFilterClearBtn: false,
                delimiterText: ', ',
                selectAllText: '<a href="javascript:;" class="multiselect-select-all btn btn-link">Select all</a>'
                    + ' | '
                    + '<a href="javascript:;" class="multiselect-select-none btn btn-link">Select none</a>',
                templates: {
                    filter: '<div class="multiselect-item multiselect-filter"><div class="input-group"><input class="multiselect-search" type="text"></div></div>'
                }
            },
            delayed_preselect: ''
        },

        _create : function() {
            var self = this,
                widgetOptions = this.options,
                $select = this.element,
                width = widgetOptions.width,
                wrapper = $select.parent();

            self.options.multiple = Boolean($select.attr('multiple'));
            $select.attr('multiple', 'multiple');

            wrapper.addClass(widgetOptions.divClass);
            width = String(width);

            if (width.indexOf('px') == -1
                && width.indexOf('auto') == -1
                && width.indexOf('%') == -1)
            {
                this.options.width = width + 'px';
            }

            wrapper.width(this.options.width);

            if (widgetOptions.displaySelectedText) {
                widgetOptions.multiselectOptions.buttonText = function(options, select) {
                    var buttonTitle = self.getSelectedOptionsText(options, select);

                    return buttonTitle;
                };
            } else {
                widgetOptions.multiselectOptions.buttonText = function() {
                    return '';
                };
            }

            widgetOptions.multiselectOptions.optionClass = function(element) {
                var liClass = 'multiselect-list-item';

                if ($(element).parent('optgroup').length) {
                    liClass += ' subItem';
                    liClass += ' ' + $(element).parent('optgroup').attr('label').trim().replace(/\s/ig, '_');
                } else if (!$(element).is('optgroup')) {
                    liClass += ' listItem';
                } else if ($(element).is('optgroup') && widgetOptions.multiple === false) {
                    liClass += ' non-clickable';
                }
                return liClass;
            };

            if (!self.options.multiple) {
                widgetOptions.multiselectOptions.includeSelectAllOption = false;
                widgetOptions.multiselectOptions.enableClickableOptGroups = false;

                widgetOptions.multiselectOptions.onChange = function(option) {
                    var values = [];

                    $('option:selected', $select).each(function() {
                        if ($(this).val() !== option.val()) {
                            values.push($(this).val());
                        }
                    });

                    $select.multiselect('deselect', values);
                };
            }

            widgetOptions.multiselectOptions.onDropdownShown = function() {
                self.clearFilter();
                self.makeFixedSearchBox();
                self.sortItems();
                self.bindSelectControlsEvent();
                self.rebuildGroups();

                self.options.$multiselectContainer.find('div.multiselect-filter input').focus();
                self.options.$checkboxItemsContainer.find('li.multiselect-list-item a.selected').removeClass('selected');
                self.options.$checkboxItemsContainer.find('li.multiselect-list-item:not(.divider):not(.disabled):not(.fake):not(.multiselect-all):first a').addClass('selected');

                self.bindKeydownEvent();
                self.bindMouseMoveEvent();
                self.options.$multiselectContainer.width(self.options.width);
                self.options.$checkboxItemsContainer.css('max-height', self.options.maxHeight);
            };

            widgetOptions.multiselectOptions.onInitialized = function() {
                self.options.$multiselectContainer = $select.next('.btn-group').find('ul.multiselect-container');
                self.options.$multiselectContainer.attr('id', self.element.attr('name'));

                setTimeout(function() {
                    // self.options.$multiselectContainer.addClass('hidden');
                    // self.options.$multiselectContainer.parent().find('.multiselect.dropdown-toggle').click();
                    // self.options.$multiselectContainer.parent().find('.multiselect.dropdown-toggle').click();
                    // self.options.$multiselectContainer.removeClass('hidden');
                    if(!self.options.showTitle){
                        self.options.$multiselectContainer.parent().find('.multiselect.dropdown-toggle').removeAttr('title');
                    }
                }, 100);
            };

            $select.multiselect(widgetOptions.multiselectOptions);
        },

        getSelectedOptionsText: function(options) {
            var widgetOptions = this.options,
                $select = this.element,
                $optgroups = $('optgroup', $select),
                delimiter = widgetOptions.multiselectOptions.delimiterText,
                title = [];

            if ($select.attr('disabled')) {
                return widgetOptions.multiselectOptions.disabledText;
            } else if (options.length === 0) {
                return '<span class="placeholder">' + widgetOptions.placeholder + '</span>';
            } else {
                $optgroups.each(function() {
                    var $selectedOptions = $('option:selected', $(this));
                    var $options = $('option', $(this));

                    if ($selectedOptions.length == $options.length) {
                        title.push($(this).attr('label'));
                    } else {
                        $selectedOptions.each(function() {
                            title.push($(this).text());
                        });
                    }
                });

                var $remainingOptions = $('option:selected', $select).not('optgroup option');

                $remainingOptions.each(function() {
                    if ($(this).attr('label') != undefined) {
                        title.push($(this).attr('label'));
                    } else {
                        title.push($(this).text());
                    }
                });
                title = title.join(delimiter);

                if (title.length > 30) {
                    title = title.substr(0, 30);
                    title += '...';
                }

                if (widgetOptions.multiple !== false) {
                    title += ' (' + options.length + ')';
                }

                return title;
            }
        },

        clearFilter: function() {
            var $select = this.element;

            $('div.multiselect-filter input').val('');
            $select.multiselect('rebuild');
        },

        makeFixedSearchBox: function() {
            var self = this,
                $lis = self.options.$multiselectContainer.find('li');

        var wrapper = '<ul class="multiselect-container dropdown-menu checkbox-items-container"></ul>';
            $lis.wrapAll(wrapper);
            self.options.$checkboxItemsContainer = self.options.$multiselectContainer.find('ul.checkbox-items-container');
        },

        bindSelectControlsEvent: function() {
            var self = this;

            self.options.$checkboxItemsContainer.find('.multiselect-select-all').on('click', function() {
                self.changeAllCheckboxes('checked');
            });
            self.options.$checkboxItemsContainer.find('.multiselect-select-none').on('click', function() {
                self.changeAllCheckboxes('unchecked');
            });
        },

        rebuildGroups: function() {
            var self = this,
                $select = this.element;

            $('li.multiselect-group', self.options.$checkboxItemsContainer).each(function() {
                var option = $(this).nextUntil('.listItem, .multiselect-group, .divider')
                    .not('.disabled')
                    .last();

                if (!$(option).next('li.multiselect-group.hidden').length) {
                    $(option).after('<li class="multiselect-group hidden"><label>~</label></li>');
                }
            });

            $select.multiselect('updateOptGroups');
        },

        changeAllCheckboxes: function(value) {
            var $select = this.element;

            if (value == 'checked') {
                $select.multiselect('selectAll', true, true);
            } else if (value == 'unchecked') {
                $select.multiselect('deselectAll', true, true);
            }

            $select.multiselect('updateButtonText');
            $select.trigger('change');
        },

        sortItems: function() {
            var self = this;

            self.options.$checkboxItemsContainer.find('li.divider').remove();
            self.options.$checkboxItemsContainer.find('li.fake').remove();

            self.options.$checkboxItemsContainer.find('li.multiselect-group:not(.hidden)').each(function() {
                var groupHeaderElement = $(this),
                    groupLabel = $(groupHeaderElement).find('label').text().trim()
                        .replace(/[!"#$%&'()*+,.\/:;<=>?@\[\\\]\^_`{|}~]/g, '\\$&').replace(/\s/ig, '_'),
                    groupItems = self.options.$checkboxItemsContainer.find('.' + groupLabel),
                    groupItemsActive = self.options.$checkboxItemsContainer.find('.' + groupLabel + '.active'),
                    groupItemsInActive = self.options.$checkboxItemsContainer.find('.' + groupLabel + ':not(.active)'),
                    itemsCnt = groupItems.length,
                    selectedItemsCnt = groupItemsActive.length;

                if (selectedItemsCnt == 0 || selectedItemsCnt == itemsCnt) {
                    var $groupContainer = $('<li class="multiselect-list-item multiselect-group-container"></li>');

                    if (selectedItemsCnt == itemsCnt) {
                        $groupContainer.addClass('active');
                    }

                    $groupContainer.append(groupHeaderElement);
                    $groupContainer.append($(groupItems));

                    self.options.$checkboxItemsContainer.append($groupContainer);
                } else {
                    var $selectedGroupContainer = $('<li class="multiselect-list-item multiselect-group-container active"></li>');

                    $selectedGroupContainer.append(groupHeaderElement.clone().addClass('fake'));
                    $selectedGroupContainer.find('.multiselect-group input').remove();
                    $selectedGroupContainer.append($(groupItemsActive));

                    var $nonSelectedGroupContainer = $('<li class="multiselect-list-item multiselect-group-container"></li>');

                    $nonSelectedGroupContainer.append(groupHeaderElement);
                    $nonSelectedGroupContainer.append($(groupItemsInActive));

                    self.options.$checkboxItemsContainer.append($selectedGroupContainer, $nonSelectedGroupContainer);
                }
            });

            self.options.$checkboxItemsContainer.children('li.multiselect-list-item').sort(function(li1, li2) {
                var li1Weight = 1000, li2Weight = 1000;

                if ($(li1).hasClass('active')) {
                    li1Weight = -1000;
                }
                if ($(li2).hasClass('active')) {
                    li2Weight = -1000;
                }
                if (($(li1).find('label').first().text()) < ($(li2).find('label').first().text())) {
                    li2Weight += 1;
                } else {
                    li1Weight += 1;
                }

                return li1Weight - li2Weight;
            }).appendTo(self.options.$checkboxItemsContainer);

            self.options.$checkboxItemsContainer.find('li.multiselect-group-container').each(function() {
                $(this).replaceWith($(this).children('li'));
            });
            self.options.$checkboxItemsContainer.find('li.active:last')
                .after('<li class="divider"></li>');
        },

        bindKeydownEvent: function() {
            var self = this;

            self.options.$multiselectContainer.off('keydown.multiselect').on('keydown.multiselect', function(event) {
                if ($.inArray(event.keyCode, [9, 38, 40, 13, 27]) === -1) {
                    setTimeout(function() {
                        $('li.multiselect-list-item a.selected', self.options.$checkboxItemsContainer).removeClass('selected');
                        $('li.multiselect-list-item:not(.divider, .disabled, .multiselect-filter-hidden, .non-clickable):first a',
                            self.options.$checkboxItemsContainer).addClass('selected');
                    }, 310);
                    return;
                }

                if ((event.keyCode === 9 ||event.keyCode === 27) && self.options.$multiselectContainer.parent('.btn-group').hasClass('open')) {
                    self.options.$multiselectContainer.parent().find('.multiselect.dropdown-toggle').click().focus();
                } else {
                    var $items = self.options.$checkboxItemsContainer.find("li:not(.divider, .disabled, .fake, .multiselect-all, .non-clickable) a").filter(":visible");

                    if (!$items.length) {
                        return;
                    }

                    var index = $items.index($items.filter('.selected'));

                    if (event.keyCode === 38 && index > 0) {
                        index--;
                    } else if (event.keyCode === 40 && index < $items.length - 1) {
                        index++;
                    } else if (!~index) {
                        index = 0;
                    }

                    var $current = $items.eq(index);

                    $items.filter('.selected').removeClass('selected');
                    $current.addClass('selected');

                    if (index > 5) {
                        self.options.$checkboxItemsContainer.scrollTo(index * 24 - 142);
                    }

                    if (event.keyCode === 32 || event.keyCode === 13) {
                        var $checkbox = $current.find('input');

                        $checkbox.prop("checked", !$checkbox.prop("checked"));
                        $checkbox.change();
                    }

                    event.stopPropagation();
                    event.preventDefault();
                }
            });
        },

        bindMouseMoveEvent: function() {
            var self = this;

            $('li:not(.divider):not(.disabled):not(.multiselect-all) a', self.options.$multiselectContainer).on('mousemove', function() {
                var $items = self.options.$checkboxItemsContainer.find("li:not(.divider):not(.disabled):not(.multiselect-all) a").filter(":visible");

                $items.filter('.selected').removeClass('selected');
                $(this).addClass('selected');
            });
        },

        setOnChangeFunction: function(callbackFunction) {
            this.setMultiselectEventCallback('onChange', callbackFunction);
        },

        setOnSelectAllFunction: function(callbackFunction) {
            this.setMultiselectEventCallback('onSelectAll', callbackFunction);
        },

        setOnDeselectAllFunction: function(callbackFunction) {
            this.setMultiselectEventCallback('onDeselectAll', callbackFunction);
        },

        setMultiselectEventCallback: function(eventName, callbackFunction) {
            if (!callbackFunction || !$.isFunction(callbackFunction)) {
                return;
            }

            var widgetOptions = this.options,
                $select = this.element,
                option = {};

            var callback = function() {
                var args = Array.prototype.slice.call(arguments);

                callbackFunction.apply(null, args);

                if (widgetOptions.multiselectOptions[eventName]
                    && $.isFunction(widgetOptions.multiselectOptions[eventName])) {
                    widgetOptions.multiselectOptions[eventName].apply(null, args);
                }
            };

            option[eventName] = callback;
            $select.multiselect('setOptions', option);
        },

        getValues: function () {
            var values = [];

            $('option:selected', $(this.element)).each(function () {
                values.push($(this).val());
            });

            return values;
        },

        setValues: function (items) {
            var self = this;
            var currentSelect = self.getValues();
            var delayed_preselect = this.options.delayed_preselect;

            if (delayed_preselect.length) {
                delayed_preselect = delayed_preselect.split(',');
            }

            self.element.html('');

            items.forEach(function (item) {
                if (Array.isArray(item.items)) {
                    var group = item;
                    var $optgroup = $('<optgroup/>').attr('label', group.title);

                    group.items.forEach(function (groupItem) {
                        var option = $('<option/>');
                        option.attr('value', groupItem['id']);
                        option.attr('label', groupItem['label']);
                        option.text(groupItem['label']);

                        if ($.inArray(groupItem['id'], delayed_preselect) > -1) {
                            option.prop('selected', true);
                        }

                        $optgroup.append(option);
                    });

                    self.element.append($optgroup);
                }
            });

            this.element.multiselect(this.options.multiselectOptions);
            this.element.multiselect('rebuild');
            this.selectValues(currentSelect, false);
            this.options.delayed_preselect = ''
        },

        selectValues: function (selectValues, triggerOnChange) {
            var self = this;
            setTimeout(function() {
                self.element.multiselect('select', selectValues, triggerOnChange);
                self.element.multiselect('updateButtonText');
                self.element.trigger('change');
                if(!self.options.showTitle){
                    self.options.$multiselectContainer.parent().find('.multiselect.dropdown-toggle').removeAttr('title');
                }
            });
        }

    });
})(jQuery);
